module.exports = __webpack_public_path__ + "img/wordpress.2a564b2e.png";